import { registerPlugin } from '@capacitor/core';

const PrinterManager = registerPlugin<any>('PrinterManager');

export default PrinterManager;
